import styles from '@/components/Home/MathToolsIcon.module.scss'
import { H3, HeadingProps } from '@edwin-edu/ui/src/lib/Heading'
import React, { FC } from 'react'

export const MathToolsIconText: FC<HeadingProps> = ({ children, ...rest }) => (
  <H3 className={styles.iconText} {...rest}>{children}</H3>
)
